module.exports = __webpack_public_path__ + "media/images/logos/Queen-Mary-University-99c1272a65ce4f9b57d96da5a4207784.svg";